<div>
	<h4 *ngIf="label" class="mb-2">{{ label }}</h4>
	<form #myForm="ngForm" (ngSubmit)="_onSubmit(myForm.form)">
		<app-container type="dark">
			<div class="flex flex-col">
				<app-input
					label="Company Name"
					[required]="true"
					[submitted]="myForm.submitted"
					[name]="labels.NAME"
					type="text"
					[(ngModel)]="_name"
					[testHook]="testHooks.CompanyName"
				></app-input>
				<app-address
					class="mt-4"
					[required]="true"
					[submitted]="myForm.submitted"
					[address]="_address"
					[enableCountrySelect]="false"
					name="Address"
					(onAddressUpdate)="onAddressUpdate($event)"
				>
				</app-address>
				<div [ngClass]="{ 'flex justify-between mt-4': !minify }">
					<app-input
						label="Work phone"
						[name]="labels.PHONE_NUMBER"
						type="tel"
						[(ngModel)]="_phoneNumber"
						[ngClass]="{ 'mt-4': minify }"
						[testHook]="testHooks.WorkPhone"
					></app-input>
					<app-input
						label="Fax"
						[name]="labels.FAX_NUMBER"
						type="tel"
						[(ngModel)]="_fax"
						class="mt-4"
						[ngClass]="{ 'mt-4': minify, 'ml-2': !minify }"
						[testHook]="testHooks.Fax"
					></app-input>
				</div>

				<app-input
					label="Email"
					[name]="labels.EMAIL"
					type="email"
					[(ngModel)]="_email"
					class="mt-4"
					[testHook]="testHooks.Email"
				></app-input>
			</div>
		</app-container>

		<div class="flex justify-between mt-5">
			<app-button
				type="button"
				btn="secondary"
				size="small"
				(click)="_onCancel()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<div *ngIf="_id; else create">
				<app-button
					type="submit"
					size="small"
					[loading]="loading"
					[disabled]="myForm.pristine && !addressChanged"
					[testHook]="testHooks.SaveButton"
					>Save</app-button
				>
			</div>
			<ng-template #create>
				<app-button
					type="submit"
					size="small"
					[loading]="loading"
					[disabled]="myForm.invalid"
					[testHook]="testHooks.CreateButton"
					>Create</app-button
				>
			</ng-template>
		</div>
	</form>
</div>
